import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router)
const router = new Router({
    mode: "hash",
    routes: [
        { path: '/', component: () => import('../view/home.vue') },
        { path: '/locator', name: 'locator', component: () => import('../view/locator.vue') },
        { path: '/contact', name: 'contact', component: () => import('../view/contact.vue') },
        { path: '/pro', name: 'pro', component: () => import('../view/pro.vue') },
        { path: '/about/:id', name: 'about', component: () => import('../view/about.vue') },
        { path: '/shop', name: 'shop', component: () => import('../view/shop.vue') },
        { path: '/jion', name: 'jion', component: () => import('../view/jion.vue') }
    ]
});

export default router